import React from 'react';
import Grid from '@material-ui/core/Grid';
import MultiLineBlock from '../multilineBlock/multilineBlock';
import CharacterMultiLineBlock from '../characterBlock/characterBlock';
import WordBlock from '../wordBlock/wordBlock';
import AllBlock from '../allBlock/allBlock';

import MotionViewBackground from './motionViewBackground';

import './motionView.scss';

export default class MotionView extends React.Component {

	constructor() {
		super();
		this.state = {editMode: false};
	}

	componentDidMount() {
		window.addEventListener('keydown', this.onKeyDown);
	}

	componentWillUnmount() {
		window.removeEventListener('keydown', this.onKeyDown);
	}

	onKeyDown = (e) => {
		const {editMode} = this.state;
		const {onAnimationRefresh, onShowControllerChange, onGalleryModeChange} = this.props;
		const activeElementIsInput = document.activeElement.tagName === 'INPUT';

		// Don't handle keydown events when focused in an input field.
		if(activeElementIsInput) return;

		switch(e.keyCode) {

			case 27: // Escape
			
				if(editMode) {
					e.preventDefault();
					this.setState({editMode: false});
				}
				return;

			case 69: // e
				if(!editMode) {
					e.preventDefault();
					this.setState({editMode: true});
				}
				
				return;

			case 70: // f
				if(!editMode) {
					e.preventDefault();
					onAnimationRefresh();
				}
				return;
			
			case 71: // g 

				if(!editMode) {
					e.preventDefault();
					onGalleryModeChange();
				}
				return;

			case 84: // t
				if(!editMode) {
					e.preventDefault();
					onShowControllerChange();
				}
				return;


			default: 
				return;
		}
	}

	onEditModeChange = (inEditMode) => {		
		this.setState({editMode: inEditMode});
	}

	onClick = (e) => {
		const {onAnimationRefresh} = this.props;
		const currentWidth = window.innerWidth;
		const currentHeight = window.innerHeight;

		if(currentWidth <= 768) {
			if(currentHeight - e.touches[0].pageY < 75) {
				onAnimationRefresh();
			}
		}
	}

	render() {

		const {
			copy,
			transitionOptions,
			fontOptions,
			backgroundOptions,
			onCopyChange,
		} = this.props;
		
		const {editMode} = this.state;
		
		return (
			<Grid container direction="column" justify="center" alignItems="center">
				<div 
					className="motionView"
					style={{perspective: transitionOptions.perspective ? `${transitionOptions.perspectiveFOV ? transitionOptions.perspectiveFOV : 1000}px` : 'unset'}}
					onTouchStart={this.onClick}
				>
					<MotionViewBackground backgroundOptions={backgroundOptions} inEditMode={editMode} />
	
					{transitionOptions.reveal === 'character' && (					
						<CharacterMultiLineBlock
							fontOptions={fontOptions}
							transitionOptions={transitionOptions}
							copy={copy}
							onChange={onCopyChange}
							onEditModeChange={this.onEditModeChange}
							inEditMode={editMode}
						/>
					)}
	
	
					{transitionOptions.reveal === 'word' && (
						<WordBlock
							fontOptions={fontOptions}
							transitionOptions={transitionOptions}
							copy={copy}
							onChange={onCopyChange}
							onEditModeChange={this.onEditModeChange}
							inEditMode={editMode}
						/>
					)}
	
					{transitionOptions.reveal === 'multiline' && (
						<MultiLineBlock 
							fontOptions={fontOptions}
							transitionOptions={transitionOptions}
							copy={copy}
							onChange={onCopyChange}
							onEditModeChange={this.onEditModeChange}
							inEditMode={editMode}
						/>
					)}
	
					{transitionOptions.reveal === 'all' && (
						<AllBlock
							fontOptions={fontOptions}
							transitionOptions={transitionOptions}
							copy={copy}
							onChange={onCopyChange}
							onEditModeChange={this.onEditModeChange}
						/>
					)}
				</div>
			</Grid>
		)
	}
}